import React, { Fragment } from 'react';
import { FormattedDate } from 'react-intl';
import { Row, Col } from 'reactstrap';
import { CustomFormInput, parseDate } from '../../../../utils';
import Events from './Events';
import Accounts from './Accounts';
import Totals from './Totals';

const ShortCover = ({ info }) => {
  return (
    <Fragment>
      <Row>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Date">
            <FormattedDate value={parseDate(info.ShortCoverDate)} />
          </CustomFormInput>
        </Col>

        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Description">
            {info.ShortCoverDescription}
          </CustomFormInput>
        </Col>

        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Status">
            {info.ShortCoverStatus}
          </CustomFormInput>
        </Col>

        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Type">{info.ShortCoverType}</CustomFormInput>
        </Col>

        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Custodian">
            {info.ShortCoverCustodianName}
          </CustomFormInput>
        </Col>
      </Row>
      
      <h6>Totals</h6>
      <Totals totals={info.Totals} />

      <h6>Events</h6>
      <Events events={info.Events} />

      <h6>Accounts</h6>
      <Accounts accounts={info.Accounts} totals={info.Totals} />
    </Fragment>
  );
};

export default ShortCover;
